export default "__VITE_ASSET__f50bcd24__"